/* Impolie — show only the photos that belong to what the customer has picked,
   and keep the slider arrows cycling through just those.

   Two filters run, in order:

     colour      alt text carries "— <Colour>", as it always has.
     set style   only where SET_STYLE below has an entry. A colour that is not
                 listed is not filtered by set style at all, which is why Navy
                 and Black keep showing their front, side and back whichever
                 style is chosen — no other photo of them exists.

   Nothing is ever reordered here. The photos sit on the product in one order
   that already contains every set style's sequence, so hiding is enough:

     navy   front · side · back · parga front · parga side · parga back
                  · life 3 · life 4
     grey   front · side · back · parga front · parga side · parga back
                  · life 3 · life 1 · life 2 · life 4 · close-up

   Changing the set style makes the theme jump to the variant's featured photo,
   which may be one this filter has just hidden, so after each pass the first
   photo still showing is brought to the front. */
(function () {
  'use strict';

  var SET_STYLE = {
    'airport-lounge-set': {
      'navy': {
        'hoodie + pants': [
          '-navy-front', '-navy-side', '-navy-back', '-navy-life-4',
          '-navy-detail'],
        'hoodie + parga shorts': [
          '-navy-parga-front', '-navy-parga-side', '-navy-parga-back', '-navy-life-3',
          '-navy-detail'],
        '3-piece bundle hoodie + pants + parga shorts': [
          '-navy-front', '-navy-side', '-navy-back', '-navy-parga-front',
          '-navy-life-3', '-navy-life-4', '-navy-detail']
      },
      'black': {
        'hoodie + pants': [
          '-black-front', '-black-side', '-black-back', '-black-life-1',
          '-black-detail'],
        'hoodie + parga shorts': [
          '-black-parga-front', '-black-parga-side', '-black-parga-back', '-black-life-2',
          '-black-detail'],
        '3-piece bundle hoodie + pants + parga shorts': [
          '-black-front', '-black-side', '-black-back', '-black-life-1',
          '-black-parga-front', '-black-life-2', '-black-detail']
      },
      'grey': {
        'hoodie + pants': [
          '-grey-front', '-grey-side', '-grey-back',
          '-grey-life-3', '-grey-life-1', '-grey-life-2', '-grey-detail'],
        'hoodie + parga shorts': [
          '-grey-parga-front', '-grey-parga-side', '-grey-parga-back',
          '-grey-life-4', '-grey-detail'],
        '3-piece bundle hoodie + pants + parga shorts': [
          '-grey-front', '-grey-side', '-grey-back', '-grey-parga-front',
          '-grey-life-3', '-grey-life-4', '-grey-detail']
      }
    }
  };

  function handle() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function tidy(s) { return (s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }

  function colourFromForm(root) {
    var picked = null;
    root.querySelectorAll('fieldset.product-form__input').forEach(function (fs) {
      var legend = fs.querySelector('legend');
      if (!legend || !/colou?r/i.test(legend.textContent)) return;
      var on = fs.querySelector('input:checked');
      if (on) picked = (on.value || '').trim();
      var sel = fs.querySelector('select');
      if (!picked && sel) picked = (sel.value || '').trim();
    });
    if (!picked) {
      var sel = root.querySelector('variant-selects select, .product-form__input select');
      if (sel) {
        var opt = sel.options[sel.selectedIndex];
        if (opt) picked = opt.value.trim();
      }
    }
    return picked;
  }

  /* The set style group is found by its label, the same way the colour group
     is — "Set style" on this theme renders as a plain pill fieldset on some
     products and a select on others. */
  function styleFromForm(root) {
    var picked = null;
    root.querySelectorAll('.product-form__input').forEach(function (fs) {
      var lg = fs.querySelector('legend, label.form__label');
      if (!lg || !/^\s*set\s*style\b/i.test(lg.textContent.replace(/\s+/g, ' '))) return;
      var on = fs.querySelector('input:checked');
      if (on) { picked = (on.value || '').trim(); return; }
      var sel = fs.querySelector('select');
      if (sel) picked = (sel.value || '').trim();
    });
    return picked;
  }

  function listFor(colour, style) {
    var byColour = SET_STYLE[handle()];
    if (!byColour) return null;
    var byStyle = byColour[tidy(colour)];
    if (!byStyle) return null;
    return byStyle[tidy(style)] || null;
  }

  function fileOf(img) {
    if (!img) return '';
    return (img.getAttribute('src') || '') + ' ' + (img.currentSrc || '') + ' ' +
           (img.getAttribute('srcset') || '') + ' ' + (img.getAttribute('data-src') || '');
  }

  function inList(li, list) {
    var src = fileOf(li.querySelector('img')).toLowerCase();
    for (var i = 0; i < list.length; i++) if (src.indexOf(list[i]) !== -1) return true;
    return false;
  }

  /* The theme's own jump may have landed on a photo this pass has hidden, and
     it makes that jump after the change event this script listens to — so this
     runs again from an observer on the gallery rather than once, inline. With
     the chosen photo hidden the viewer has nothing to show and the customer
     gets an empty frame where the picture should be. */
  /* The theme answers a variant change in two steps, and the second one lands
     after this script has already run and after it has already corrected the
     gallery once — so one correction is not enough, and refusing to repeat it
     leaves the viewer showing a photo that is hidden, which is an empty frame.
     Allow a bounded run of attempts instead: enough to outlast the theme,
     capped so a photo that genuinely will not take cannot spin. */
  var attempts = 0;
  var MAX_ATTEMPTS = 10;

  function focusFirstVisible(root, fromObserver) {
    var thumbs = [];
    root.querySelectorAll('.thumbnail-list__item').forEach(function (li) {
      if (!li.hidden && li.getBoundingClientRect().width > 0) thumbs.push(li);
    });

    if (thumbs.length) {
      // desktop: one photo is on show and the theme marks it, so the marker is
      // worth trusting and worth correcting whenever the theme moves it
      var active = root.querySelector('.product__media-item.is-active');
      var current = root.querySelector('.thumbnail-list__item [aria-current="true"]');
      var holder = current && current.closest('.thumbnail-list__item');
      if (active && !active.hidden && holder && !holder.hidden) { attempts = 0; return; }
      if (attempts >= MAX_ATTEMPTS) return;
      var btn = thumbs[0].querySelector('button, a');
      if (!btn) return;
      attempts++;
      btn.click();                                 // the theme's own handler
      return;
    }

    /* Mobile: no thumbnails, the photos are a swipeable strip, and the theme
       leaves its "currently showing" marker on whichever photo it jumped to —
       it never moves it again as you swipe. In the Parga view that photo is
       hidden, so the marker reads as wrong for as long as you stay there. Judge
       the strip by where it is scrolled to instead, and only ever correct it
       straight after a filter pass: correcting from the observer as well drags
       the strip back to the first photo on every twitch the gallery makes
       while a finger is on it, which reads as the gallery refusing to swipe. */
    if (fromObserver) return;
    var list = root.querySelector('.product__media-list');
    if (!list) return;
    var first = null;
    root.querySelectorAll('.product__media-item').forEach(function (li) {
      if (!first && !li.hidden) first = li;
    });
    if (!first) return;
    // a hidden photo takes up no room, so the first one showing sits at 0
    if (Math.abs(list.scrollLeft - first.offsetLeft) < 4) return;
    try { list.scrollTo({ left: first.offsetLeft, behavior: 'auto' }); }
    catch (e) { list.scrollLeft = first.offsetLeft; }
  }

  function watch(root) {
    var gallery = root.querySelector('media-gallery');
    if (!gallery || gallery.getAttribute('data-imp-watched')) return;
    gallery.setAttribute('data-imp-watched', '1');
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; focusFirstVisible(root, true); });
    }).observe(gallery, {
      subtree: true, childList: true, attributes: true,
      attributeFilter: ['class', 'aria-current', 'hidden', 'style'],
    });
  }

  function apply(root) {
    var colour = colourFromForm(root);
    if (!colour) return;
    attempts = 0;
    var list = listFor(colour, styleFromForm(root));
    var slides = root.querySelectorAll('.product__media-item, .thumbnail-list__item');
    var shown = 0;
    slides.forEach(function (li) {
      var img = li.querySelector('img');
      var alt = ((img && img.getAttribute('alt')) || '').toLowerCase();
      var c = colour.toLowerCase();
      var match = alt.indexOf('— ' + c) !== -1 || alt.indexOf('- ' + c) !== -1;
      if (match && list) match = inList(li, list);
      li.hidden = !match;
      li.style.display = match ? '' : 'none';
      if (match) shown++;
    });
    if (!shown) {                      // nothing matched — show everything
      slides.forEach(function (li) { li.hidden = false; li.style.display = ''; });
    }
    // Put the gallery on a photo that is actually showing BEFORE handing back
    // to the theme's paging. Its update() reads the slide its counter sits on,
    // which this pass may have just hidden, and then it throws — and anything
    // after it in this function would never run.
    if (shown) focusFirstVisible(root, false);

    var slider = root.querySelector('slider-component');
    if (slider && typeof slider.initPages === 'function') {
      try {
        slider.initPages();
        if (typeof slider.update === 'function') slider.update();
      } catch (e) {
        // its counter catches up on the next scroll; losing it is not worth
        // losing the rest of this pass over
      }
    }
  }

  function bind() {
    document.querySelectorAll('section[id*="main-product"], .product').forEach(function (root) {
      apply(root);
      watch(root);
      root.addEventListener('change', function () { setTimeout(function () { apply(root); }, 60); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
  document.addEventListener('shopify:section:load', bind);
})();
